export * from './chat-solicitacao.component';
